<div class="form_container dialog_form">
  <mat-dialog-content class="w-100">{{ data.body | translate}}</mat-dialog-content>
      <div class="dialog_form_buttons">
        <button mat-button class="submit_btn" (click)="yesClicked()">{{ data.saveButtonText | translate}}</button>
        <button mat-button *ngIf="!data.withoutDiscard" class="action_btn" (click)="noClicked()">{{ data.discardButtonText |
          translate}}</button>
    </div>    
</div>